import { render } from "./FavoriteImages.vue?vue&type=template&id=6f80e142&scoped=true"
import script from "./FavoriteImages.vue?vue&type=script&lang=js"
export * from "./FavoriteImages.vue?vue&type=script&lang=js"

import "./FavoriteImages.vue?vue&type=style&index=0&id=6f80e142&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f80e142"]])

export default __exports__